export default __webpack_public_path__ + "static/media/r56.f6f2a00a.jpg";